export const APP_TITLE = "Desy Adelina R";
export const LOADING_DURATION = 1800;
